import React from "react";
import CommonPersonal from "./CommonPersonal";

const PersonalTwo = () => {
  return (
    <div>
      <CommonPersonal items={12} condition={false} />
    </div>
  );
};

export default PersonalTwo;
